
/**
 * @param {Object} flashcard - The current flashcard document.
 * @param {number} quality - A score from 0 to 5 (based on user feedback).
 * @returns {Object} - Updated values to merge into Firestore.
 */
export function updateSM2(flashcard, quality) {
  let { EF = 2.5, repetitions = 0, interval = 0 } = flashcard;

  if (quality >= 3) {
    repetitions += 1;
    if (repetitions === 1) {
      interval = 1;
    } else if (repetitions === 2) {
      interval = 6;
    } else {
      interval = Math.round(interval * EF);
    }
  } else {
    repetitions = 0;
    interval = 1;
  }

  // Adjust EF (ease factor)
  EF = EF + (0.1 - (5 - quality) * (0.08 + (5 - quality) * 0.02));
  if (EF < 1.3) EF = 1.3;

  const now = new Date();
  const dueDate = new Date(now.getTime() + interval * 24 * 60 * 60 * 1000);

  return {
    EF,
    repetitions,
    interval,
    dueDate,
    lastReviewed: now,
  };
}